import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "/offers/search",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const clientOffer = require("./ClientOffer").default;
          cb(null, clientOffer);
        },
        "ClientOffer"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/ClientOffers/index.js